import axios from 'axios';

// Same-origin in production; proxied to the API in local dev (vue.config.js '/api/v2').
export const v2Api = axios.create({
  baseURL: '/api/v2',
  withCredentials: true,
  headers: { 'X-Requested-With': 'tierlist-v2' },
});
